import TNavs from './navs.vue'
import TNavsItem from './navs-item.vue'

TNavs.install = Vue => {
  Vue.component(TNavs.name, TNavs)
}

TNavsItem.install = Vue => {
  Vue.component(TNavsItem.name, TNavsItem)
}

export {
  TNavs,
  TNavsItem
}



// WEBPACK FOOTER //
// ./src/module/navs/index.js